/**
 * @generated SignedSource<<6a4bd0eb218a2e81566bf72cd5366e81>>
 * @relayHash cf8fc4ca3f006b0ac5870960c68d76b9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6a5f99ee754575c3b9a27024f01bbcdeff0bb3345ed2ab4caaae9b332e513e59

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { SupportWebsiteNavEntryPointQuery } from './SupportWebsiteNavEntryPointQuery.graphql';

const node: PreloadableConcreteRequest<SupportWebsiteNavEntryPointQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "6a5f99ee754575c3b9a27024f01bbcdeff0bb3345ed2ab4caaae9b332e513e59",
    "metadata": {},
    "name": "SupportWebsiteNavEntryPointQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
